export default {
    MANUAL_NONE: -1,
    MANUAL_SINGLE: 0,
    MANUAL_GROUP: 1,
    MANUAL_ROBOT: 4,
    // 旧版导航
    MANUAL_OLD_NAV: 2,
    // 新版导航
    MANUAL_NAV: 5,
    MANUAL_ROUTE: 8,
    MANUAL_RULE: 6,
    MANUAL_LEAVE: 7,

    // 机器人独立版
    MANUAL_INDEPENDENT: 9,
    MANUAL_INDEPENDENT_SINGLE: 7, // 独立版单人接待
};
